import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsageDetailsComponent } from './usage-details.component';

const routes: Routes = [
	{ path: '', component: UsageDetailsComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsageRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/usage/usage-routing.module.ts